var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { BaseActions } from '../base-actions';
import { LanguageService } from '../../services/language/language.service';
var ErrorPageComponent = /** @class */ (function (_super) {
    __extends(ErrorPageComponent, _super);
    function ErrorPageComponent(languageService) {
        var _this = _super.call(this) || this;
        _this.languageService = languageService;
        _this.title = 'TV SHOP TIJDELIJK OFFLINE';
        _this.description = 'We zijn momenteel aan de slag om jouw TV Shop nog beter te maken.';
        return _this;
    }
    ErrorPageComponent.prototype.ngOnInit = function () {
        if (this.isLanguageFrench()) {
            this.title = 'SHOP TV TEMPORAIREMENT HORS LIGNE';
            this.description = 'Nous travaillons actuellement à l\'amélioration de votre SHOP TV.';
        }
    };
    ErrorPageComponent.prototype.isLanguageFrench = function () {
        return this.languageService.getCurrentLanguage() === 'fr';
    };
    return ErrorPageComponent;
}(BaseActions));
export { ErrorPageComponent };
